<template>
  <div class="chartElem">
    <section class="content-header">
      <h1>
        รายงานจำนวนรายการส่งเสริมการขายบริการโทรศัพท์เคลื่อนที่จำแนกตามประเภทบริการ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"></a>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h3>ตัวเลือกการค้นหา</h3>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="ประเภทรายงาน" required>
                                <el-select ref="type_report" v-model="form.type_report" @change="clear_data">
                                  <el-option label="รายเดือน" value="month"></el-option>
                                  <el-option label="ระหว่างเดือน" value="between_month"></el-option>
                                  <el-option label="รายปี" value="year"></el-option>
                                  <el-option label="ระหว่างปี" value="between_year"></el-option>
                                  <el-option label="ไตรมาส" value="quarter"></el-option>
                                  <el-option label="ช่วงไตรมาส" value="between_quarter"></el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item label="กรุณาเลือกประเภทรายงาน" v-if="form.type_report === ''" >
                                <el-input disabled placeholder></el-input>
                              </el-form-item>
                              <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'month' ?  '': 'not_display']" required>
                                <el-date-picker
                                  ref="month"
                                  v-model="form.type_data.month"
                                  style="width:100%;"
                                  :default-value="defaultDate"
                                  :picker-options="monthBeforeOptions"
                                  type="month"
                                  clearable
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'between_month' ?  '': 'not_display']" required>
                                <el-date-picker
                                  ref="monthfrom"
                                  :default-value="defaultDate"
                                  :picker-options="monthBeforeOptions"
                                  v-model="form.type_data.monthfrom"
                                  style="width:40%;"
                                  type="month"
                                  clearable
                                ></el-date-picker>&nbsp;-&nbsp;
                                <el-date-picker
                                  ref="monthto"
                                  :default-value="defaultDate"
                                  :picker-options="pickerOptions"
                                  v-model="form.type_data.monthto"
                                  style="width:40%;"
                                  type="month"
                                  clearable
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'year' ?  '': 'not_display']" required>
                                <el-date-picker
                                  ref="year"
                                  v-model="form.type_data.year"
                                  style="width:100%;"
                                  type="year"
                                  :default-value="defaultDate"
                                  :picker-options="yearBeforeOptions"
                                  clearable
                                  :editable="false"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'between_year' ?  '': 'not_display']" required>
                                <el-date-picker
                                  :default-value="defaultDate"
                                  ref="yearfrom"
                                  v-model="form.type_data.yearfrom"
                                  :picker-options="yearBeforeOptions"
                                  type="year"
                                ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                <el-date-picker
                                  :default-value="defaultDate"
                                  ref="yearto"
                                  v-model="form.type_data.yearto"
                                  type="year"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="ช่วงเวลา" v-bind:class="[form.type_report === 'quarter' ?  '': 'not_display']" required>
                                <el-select style="width:50%;" ref="quarter" v-model="form.type_data.quarter" >
                                  <el-option label="1" value="1"></el-option>
                                  <el-option label="2" value="2"></el-option>
                                  <el-option label="3" value="3"></el-option>
                                  <el-option label="4" value="4"></el-option>
                                </el-select>&nbsp;
                                <el-date-picker 
                                  :default-value="defaultDate" 
                                  :picker-options="quarterBeforeOptions"
                                  v-model="form.type_data.quarter_year" 
                                  ref="quarter_year" 
                                  type="year">
                                </el-date-picker>
                              </el-form-item>
                              <el-form-item label="ช่วงเวลา" v-if="form.type_report === 'between_quarter'"
                                v-bind:class="[form.type_report === 'between_quarter' ?  '': 'not_display']" required>
                                <el-select style="width:20%;" 
                                  ref="quarterfrom" 
                                  v-model="form.type_data.quarterfrom">
                                  <el-option label="1" value="1"></el-option>
                                  <el-option label="2" value="2"></el-option>
                                  <el-option label="3" value="3"></el-option>
                                  <el-option label="4" value="4"></el-option>
                                </el-select>&nbsp;
                                <el-date-picker
                                  style="width:25%;"
                                  v-model="form.type_data.quarter_year_from"
                                  :default-value="defaultDate"
                                  :picker-options="quarterBeforeOptions"
                                  ref="quarter_year"
                                  type="year"
                                ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                                <el-select
                                  style="width:20%;"
                                  ref="quarterto"
                                  v-model="form.type_data.quarterto"
                                >
                                  <el-option label="1" value="1"></el-option>
                                  <el-option label="2" value="2"></el-option>
                                  <el-option label="3" value="3"></el-option>
                                  <el-option label="4" value="4"></el-option>
                                </el-select>&nbsp;
                                <el-date-picker
                                  v-model="form.type_data.quarter_year"
                                  :default-value="defaultDate"
                                  :picker-options="pickerOptions"
                                  ref="quarter_year"
                                  type="year"
                                  style="width:25%;"
                                ></el-date-picker>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="col-sm-6">
                              <el-form-item label="ประเภทผู้ให้บริการ">
                                <el-radio-group v-model="form.compare_type" @change="compareType">
                                  <el-radio label="group">กลุ่มผู้ให้บริการ</el-radio>
                                  <el-radio label="provider">รายชื่อผู้ให้บริการ</el-radio>
                                </el-radio-group>
                              </el-form-item>
                              <el-form-item label="กลุ่มผู้ให้บริการ" :required="cType">
                                <el-checkbox-group v-model="form.provider_group" :disabled="!cType">
                                  <el-checkbox 
                                    ref="provider_group"
                                    v-for="group in this.store_groups" 
                                    :key="group.id" 
                                    :label="group.id">
                                    {{group.group_name_th}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                              <el-form-item label="รายชื่อผู้ให้บริการ" :required="!cType">
                                <el-checkbox-group v-model="form.provider_list" :disabled="cType">
                                  <el-checkbox 
                                    ref="provider_list"
                                    v-for="provider in this.store_providers" 
                                    :key="provider.id" 
                                    :label="provider.id">
                                    {{provider.brand_name}}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item label="รูปแบบรายงาน">
                                <el-radio-group v-model="form.chart_type">
                                  <el-radio label="pie">พายชาร์ต</el-radio>
                                  <el-radio label="column">แผนภูมิแท่ง</el-radio>
                                </el-radio-group>
                              </el-form-item>
                              <el-form-item label="ย่านความถี่">
                                <el-checkbox-group v-model="form.frequency">
                                  <el-checkbox label="900">900 MHz</el-checkbox>
                                  <el-checkbox label="1800">1800 MHz</el-checkbox>
                                  <el-checkbox label="2100">2.1 GHz</el-checkbox>
                                  <el-checkbox label="other">อื่นๆ</el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                            <div class="col-sm-6">
                              <el-form-item label="สถานะการให้บริการ">
                                <el-checkbox-group v-model="form.service_status">
                                    <el-checkbox label="S">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                    <el-checkbox label="U">ประเภทบุคคลทั่วไป (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                    <el-checkbox label="CS">ประเภทองค์กร (รายการส่งเสริมการขายที่ยังขายอยู่)</el-checkbox><br/>
                                    <el-checkbox label="CU">ประเภทองค์กร (รายการส่งเสริมการขายที่ไม่ขายแล้ว แต่ยังให้บริการอยู่)</el-checkbox><br/>
                                </el-checkbox-group>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="generate()">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                  <div v-if="displayCharts">
                     <div class="col-sm-12" style="text-align:right;">
                        <el-button type="primary" @click.prevent="exportDoc" v-loading="pending">
                          Export Word
                        </el-button>
                      </div>
                  </div>
                  <div id="chart" class="box-body" ref="chart" style="min-height: 500px;" v-if="displayCharts">
                    <div class="col-sm-12" v-for="chart in this.store_charts" :key="chart.id">
                      <charts class="chart" style="max-height : 400px;" :options="chart" ></charts>
                    </div>
                  </div>
                  <div class="box-body" v-if="displayText">
                    <div class="col-sm-12">
                      <h4 align="center">ไม่พบข้อมูลการค้นหา</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>
import Chart from "chart.js"
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, Media, PageOrientation, AlignmentType, HorizontalPositionAlign, VerticalPositionRelativeFrom } from "docx";
import { saveAs } from "file-saver"
import { mapState, mapActions } from "vuex";
export default {
  data () {
    return {
      pickerOptions: {
          disabledDate(time) {
            // return time.getTime() > Date.now();
          }
      },
      month_th: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม" ],
      form: {
        type_data: {
          quarter_year_from: "",
          quarter: "",
          year: "",
          monthfrom: "",
          monthto: "",
          month: "",
          quarter_year: "",
          quarterfrom: "",
          quarterto: "",
          yearfrom: "",
          yearto: ""
        },
        chart_type: "pie",
        provider_group: [],
        provider_list: [],
        frequency: ["900", "1800", "2100"],
        type_report: "",
        compare_type: "group",
        service_status : ['S','U','CS','CU']
      },
      cType : true,
      defaultDate: "",
      label_position: "top",
      monthBeforeOptions: {
        disabledDate(time) {
          // return time.getTime() < new Date(2015,12);
        },
      },
      yearBeforeOptions: {
        disabledDate(time) {
          // return time.getTime() < new Date(2013,12);
        },
      },
      quarterBeforeOptions: {
        disabledDate(time) {
          // return time.getTime() < new Date(2013,12);
        },
      },
      pending: false
    }
  },
  beforeCreate(){
    this.$store.dispatch('Report_pmt/getGroupCompany','mobile')
    this.$store.dispatch('Report_pmt/getProviderByType','mobile')
    this.$store.dispatch('Report_pmt/initChart')
  },
  computed : {
    ...mapState({
      store_groups : store => store.Report_pmt.provider_group,
      store_providers : store => store.Report_pmt.provider_list,
      store_charts : store => store.Report_pmt.charts,
      displayCharts : store =>  store.Report_pmt.displayCharts,
      displayText : store => store.Report_pmt.displayText
    })
  },
  methods : {
    ...mapActions({
      searching : 'Report_pmt/setChartData'
    }),
    clear_data(){
      this.form.type_data ={
        quarter_year_from: "",
        quarter: "",
        year: "",
        monthfrom: "",
        monthto: "",
        month: "",
        quarter_year: "",
        quarterfrom: "",
        quarterto: "",
        yearfrom: "",
        yearto: ""
      }
    },
    generate(){
      if(this.form.type_report === ""){
        this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.type_report.focus();
          }
        });
      }else if( this.form.type_report === "month" && this.form.type_data.month === ""){
        this.$alert("กรุณาเลือกเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.month.focus();
          }
        });
      }else if(this.form.type_report === "between_month" && (this.form.type_data.monthfrom === "" || this.form.type_data.monthto === "")){
        this.$alert("กรุณาเลือกระหว่างเดือน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.monthfrom.length == 0) {
              this.$refs.monthfrom.focus();
            } else {
              this.$refs.monthto.focus();
            }
          }
        });
      }else if(this.form.type_report === "year" && this.form.type_data.year === "") {
        this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.year.focus();
          }
        });
      }else if(this.form.type_report === "between_year" && (this.form.type_data.yearfrom.length === 0 ||this.form.type_data.yearto.length === 0)) {
        this.$alert("กรุณาเลือกระหว่างปี", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.yearfrom.length == 0) {
              this.$refs.yearfrom.focus();
            } else {
              this.$refs.yearto.focus();
            }
          }
        });
      }else if(this.form.type_report === "quarter" &&(this.form.type_data.quarter === "" ||this.form.type_data.quarter_year.length === 0)) {
        this.$alert("กรุณาเลือกไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            this.$refs.quarter.focus();
            if (this.form.type_data.quarter.length == 0) {
              this.$refs.quarter.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      }else if(this.form.type_report === "between_quarter" &&(this.form.type_data.quarterfrom.length === 0 ||this.form.type_data.quarterto.length === 0 ||this.form.type_data.quarter_year === "")) {
        this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          callback: action => {
            if (this.form.type_data.quarterfrom.length === 0) {
              this.$refs.quarterfrom.focus();
            } else if (this.form.type_data.quarterto.length === 0) {
              this.$refs.quarterto.focus();
            } else {
              this.$refs.quarter_year.focus();
            }
          }
        });
      }else if(this.form.provider_group.length < 1 && this.form.compare_type == 'group'){
        this.$alert("กรุณาเลือกกลุ่มผู้ให้บริการ", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      }else if(this.form.provider_list.length < 1 && this.form.compare_type != 'group'){
        this.$alert("กรุณาเลือกผู้ให้บริการ", "แจ้งเตือน", { confirmButtonText: "ตกลง"});
      }else if(this.form.chart_type == ""){
        this.$alert("กรุณาเลือกรูปแบบรายงาน", "แจ้งเตือน", { confirmButtonText: "ตกลง" });
      }else{
        let formdata = this.form
            formdata.list = this.form.compare_type == "group" ? this.store_groups.filter(item => this.form.provider_group.includes(item.id)) : this.store_providers.filter(item => this.form.provider_list.includes(item.id))
        this.searching(formdata)
      }
    },
    pickGroup(groupinfo){
      let group = JSON.parse(groupinfo.group_company_list)
      this.form.provider_list = this.form.provider_group.includes(groupinfo.id) ? this.form.provider_list.concat(group) : this.form.provider_list.filter(item => !group.includes(item))
    },
    compareType(e){
      this.cType = e == 'group' ? true : false
      if(this.cType){
        this.form.provider_list = []
      }else{
        this.form.provider_group = []
      }
    },
    async exportDoc(){
      if(this.pending) return false
      this.pending = true
      let img_list = []
      let img_prop = []
      let chart_list = document.querySelectorAll('.chart');
      for(let i = 0; i < chart_list.length; i++) {
        await this.$html2canvas(chart_list[i], { canvas: null }).then(function(canvas) {
          const img = canvas.toDataURL("image/png", 1.0);
          img_list.push(img)
          img_prop.push(canvas.width/canvas.height)
        });
      }
      const doc = new Document();
      for(let j = 0; j < img_list.length; j++) {
        const image = Media.addImage(doc, img_list[j], 920, 920/img_prop[j],{
          floating: {
            verticalPosition: {
              relative: VerticalPositionRelativeFrom.PAGE,
              offset: 2014400,
            },
            horizontalPosition: {
              align: HorizontalPositionAlign.CENTER
            }
          }
        });
        doc.addSection({
          size: {
            orientation: PageOrientation.LANDSCAPE,
          },
          children: [new Paragraph(image)]
        });
      }
      Packer.toBlob(doc).then(blob => {
        saveAs(blob, "Report_promotion_mobile_type.docx");
        this.pending = false
      });
    }
  }
}
</script>
 
<style scoped>
input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}
#colorPicker {
  border: 0;
  padding: 0;
  margin: 0;
  width: 30px;
  height: 30px;
}
.numberInput {
  width: 30px;
}
</style>